import { useEffect, useState } from "react";

/** 输入停下多久才把值放出去。一次搜索请求的等待成本远高于这点延迟。 */
const DEFAULT_DELAY_MS = 250;

/**
 * 把边打字边变的值压成停手后的一个值。搜索框直接把每次按键送进 query key 的话，
 * 一个词就是一串请求；这里只让最后一次出去。
 */
export function useDebouncedValue<TValue>(
  value: TValue,
  delayMs = DEFAULT_DELAY_MS,
): TValue {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSettled(value);
    }, delayMs);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return settled;
}
